import { render, staticRenderFns } from "./FullscreenDialog.vue?vue&type=template&id=ccc9fe1a&scoped=true"
import script from "./FullscreenDialog.vue?vue&type=script&lang=js"
export * from "./FullscreenDialog.vue?vue&type=script&lang=js"
import style0 from "./FullscreenDialog.vue?vue&type=style&index=0&id=ccc9fe1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc9fe1a",
  null
  
)

export default component.exports